import React from 'react';
import { Calendar, Clock, FileText, Building2, FolderKanban } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { LogoDisplay } from './LogoDisplay';
import { ServiceOrderWithTasks } from '../../types/serviceOrder';
import { formatDate } from '../../utils/dateUtils';

interface ServiceOrderHeaderProps {
  serviceOrder: ServiceOrderWithTasks;
  projectName?: string;
  projectLogo?: string;
}

export const ServiceOrderHeader: React.FC<ServiceOrderHeaderProps> = ({ serviceOrder, projectName, projectLogo }) => {



  const getCompanyInitials = (name: string) => {
    if (!name) return 'OS';
    return name
      .split(' ')
      .map(word => word.charAt(0).toUpperCase())
      .slice(0, 2)
      .join('');
  };

  return (
    <div className="corporate-header">
      <div className="corporate-header-content">
        {/* Left Column - Logo Area */}
        <div className="corporate-header-logo-section">
          {projectLogo ? (
            <LogoDisplay 
              projectId={serviceOrder.projectId}
              logoPath={projectLogo} 
              projectName={projectName || 'Projeto'} 
              size="large" 
              className="print:block"
              showFallback={true}
            />
          ) : (
            <div className="corporate-placeholder-company">
              <div className="corporate-placeholder-initials">
                {getCompanyInitials(projectName || 'Projeto')}
              </div>
              <div className="corporate-placeholder-name">
                {projectName || 'Projeto'}
              </div>
            </div>
          )}
        </div>

        {/* Center Column - Title and Description */}
        <div className="corporate-header-title-section">
          <div className="corporate-header-subtitle">
            Ordem de Serviço
          </div>
          
          <div className="corporate-header-title">
            <h1>{serviceOrder.name}</h1>
          </div>
          
          {serviceOrder.description && (
            <div className="corporate-header-description">
              {serviceOrder.description}
            </div>
          )}
        </div>

        {/* Right Column - Metadata */}
        <div className="corporate-header-meta-section">
          <div className="corporate-header-info-cards">
            <div className="corporate-header-info-card">
              <Calendar className="w-5 h-5 corporate-header-info-icon" />
              <div className="corporate-header-info-content">
                <div className="corporate-header-info-label">Período</div>
                <div className="corporate-header-info-value">
                  {formatDate(serviceOrder.startDate)}
                </div>
                <div className="corporate-header-info-sub">
                  até {formatDate(serviceOrder.endDate)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
